var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDressingRoom = function SvgDressingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19,
    x: 2.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.5 6.5c0-.532.392-2.207 2-1.5.76.333.572 1.147.444 1.612l-.576 1.996 4.027 1.396c.255.133.728.559.575 1.197a1.01 1.01 0 0 1-.959.798h-7.86C5.766 11.933 5 11.68 5 11.202c0-.598 0-.798.767-1.197C6.15 9.804 6.5 9.5 8 9"
  })));
};
export default SvgDressingRoom;